import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { MEAT_API, CHAVE_API } from '../app.api';
import { Usuario, Funcionario } from '../models/model';
import { DadosService } from './dados.service';
import { Observable } from 'rxjs/Observable';
import { ErrorHandler } from '../app.error-handler';
import 'rxjs/add/operator/catch';


@Injectable()
export class UsuarioService {

    private usuario: Usuario;

    constructor(private http: Http,
                private empresaService: DadosService) { }

    logar(dados: {
        usuario: string,
        senha: string
    }): Observable<Usuario> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('cnpj', this.empresaService.getEmpresa().dados.cnpj);
        headers.append('chave', CHAVE_API);
        return this.http.post(`${MEAT_API}/api/web/usuarios`, JSON.stringify(dados), new RequestOptions({ headers: headers }))
            .map((response) => {
                localStorage.setItem("currentUser", JSON.stringify(response.json()));
                return response.json();
            });
    }

    getUsuarioLogado(): Usuario {
        var currentUser = localStorage.getItem("currentUser");
        if (currentUser === "") {
            return undefined;
        }
        return JSON.parse(currentUser);
    }

    salvarUsuario(func: Funcionario): Observable<Funcionario> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('cnpj', this.empresaService.getEmpresa().dados.cnpj);
        headers.append('chave', CHAVE_API);
        return this.http.post(`${MEAT_API}/api/web/funcionariosweb`, JSON.stringify(func), new RequestOptions({ headers: headers }))
            .map((response) =>  response.json());
    }

    alteraSenhaCliente(dados: any): Observable<Funcionario> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('cnpj', this.empresaService.getEmpresa().dados.cnpj);
        headers.append('chave', CHAVE_API);
        return this.http.post(`${MEAT_API}/api/web/usuariosenha`, JSON.stringify(dados), new RequestOptions({ headers: headers }))
            .map((response) =>  response.json());
    }

    getUsuarios(): Observable<Funcionario[]> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('cnpj', this.empresaService.getEmpresa().dados.cnpj);
        headers.append('chave', CHAVE_API);
        headers.append('chcliente', this.getUsuarioLogado().id_empresa.toString());
        return this.http.get(`${MEAT_API}/api/web/funcionariosweb`, new RequestOptions({ headers: headers }))
            .map((response) =>  response.json());

    }

    getUsuario(codigo: number): Observable<Funcionario> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('cnpj', this.empresaService.getEmpresa().dados.cnpj);
        headers.append('chave', CHAVE_API);
        return this.http.get(`${MEAT_API}/api/web/funcionariosweb/${codigo}`, new RequestOptions({ headers: headers }))
            .map((response) =>  response.json());

    }

    logout(): void {
        localStorage.removeItem('currentUser');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/usuario.service.ts